
import Promise from "plugins/bluebird/index"

import ActiveSwitches from "./mark-switch-active"
import OverlayToggle from "./overlay-toggle"
import GoogleMap from "./google_map"
import GoogleStreet from "./google_street"
import Carousel from "concepts/serviced_apartment_buildings/carousel/index"

import DataRetriever from "app/data_retriever"


const init_with_promise = () => {

  const all_internal_module_init_promises = [] as Array<Promise<any>>

  Carousel.init()
  ActiveSwitches.instance()
  OverlayToggle.instance()

  all_internal_module_init_promises.push(GoogleMap.create_with_promise())

  if (! DataRetriever.get("current-location-country-code-is-china")){
    all_internal_module_init_promises.push(GoogleStreet.create_with_promise())
  }

  return Promise.all(all_internal_module_init_promises)
}

export default {
  init_with_promise,
  ActiveSwitches,
  OverlayToggle,
  GoogleMap,
  GoogleStreet,
  Carousel,
}
